module.exports = __webpack_public_path__ + "img/magnifinance.e2e51d29.png";